/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';

const alertContext = createContext({
    alert: { category: '', mssg: '' },
    showAlert: (mssg: string | JSX.Element | JSX.Element[], category: string) => {},
});

export default alertContext;
